var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnergyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F9A01B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.19 5.14431C11.2328 4.94477 11.1359 4.74143 10.954 4.64892C10.7721 4.55641 10.5507 4.59788 10.4146 4.74997L5.31465 10.45C5.19631 10.5822 5.16676 10.7717 5.2392 10.9337C5.31164 11.0957 5.47253 11.2 5.65001 11.2H9.59336L8.80999 14.8557C8.76723 15.0553 8.86411 15.2586 9.04601 15.3511C9.22791 15.4436 9.44929 15.4022 9.58536 15.2501L14.6854 9.55008C14.8037 9.41782 14.8333 9.22836 14.7608 9.06635C14.6884 8.90433 14.5275 8.80003 14.35 8.80003H10.4066L11.19 5.14431Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyIcon);
export default __webpack_public_path__ + "static/media/energy-icon.6e41789d2f56edb7a8ae23e0aa6145c1.svg";
export { ForwardRef as ReactComponent };